<div *ngIf="loadedBln">
  <!-- Navigation -->
  <nav #header class="navbar navbar-default fixed-top bg-darkest-gray">
    <my-navigation></my-navigation>
  </nav>

  <!--<div class="contact-cta">
    <div class="inner-wrapper">
      <h3>Contact</h3>
      <p>Donna Gray: <a href="tel:4162760632">416.276.0632</a></p>
    </div>
  </div>-->
  <!-- Header -->
  <div *ngIf="selectedListing!==undefined">
  <span *ngIf="currentScreenSize !== 'Large' && currentScreenSize !== 'XLarge'">
        <header [style.background-image]="getBackgroundSmall(selectedListing.listingMedia.data[0].url)">
            <div class="container">
                <div class="intro-text">
                    <div class="intro-lead-in">Offered at {{ selectedListing.listingPrice | currency : '' : 'symbol' : '1.0-0' }}</div>
                    <div class="intro-heading">{{ selectedListing.community }}</div>


                    <div *ngIf="selectedListing.virtualTourUrl">
                        <a target="_blank" class="page-scroll btn btn-xl" href="{{selectedListing.virtualTourUrl}}" style="color:red; border-color: red; padding: 20px 27px;">Virtual
                            Tour</a>
                    </div>
                    <a href="javascript:" (click)="gotoHashtag('gallery');" class="page-scroll btn btn-xl">View More</a>
                </div>
            </div>
        </header>
    </span>

    <span *ngIf="currentScreenSize==='Large' || currentScreenSize==='XLarge'">
        <header [style.background-image]="getBackground(selectedListing.listingMedia.data[0].url)">
            <div class="container">
                <div class="intro-text">
                    <div class="intro-lead-in">Offered at {{ selectedListing.listingPrice | currency : '' : 'symbol' : '1.0-0' }}</div>
                    <div class="intro-heading">{{ selectedListing.community }}</div>


                    <div *ngIf="selectedListing.virtualTourUrl">
                        <a target="_blank" class="page-scroll btn btn-xl" href="{{selectedListing.virtualTourUrl}}" style="color:red; border-color: red; padding: 20px 27px;">Virtual
                            Tour</a>
                    </div>
                    <a *ngIf="selectedListing.listingStatus!=='Rental'" href="javascript:" (click)="gotoHashtag('gallery');" class="page-scroll btn btn-xl">View More</a>
                </div>
            </div>
        </header>
    </span>

    <!-- gallery Grid Section -->
    <section id="gallery" class="bg-light-gray">
      <div class="container">
        <div class="sub-nav">
          <my-navigation-details-full [selectedListing]="selectedListing"></my-navigation-details-full>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading">Gallery</h2>

            <h3 class="section-subheading text-muted">Explore This Beautiful Property</h3>
          </div>
        </div>

        <div class="row  column-gap-4 justify-content-center">
          @for (listingMedia of selectedListing.listingMedia.data; track listingMedia.id) {
            <div class="col-md-4 col-sm-5 gallery-img" style="width: 380px; height: 219px;">
              <a href="{{listingMedia.url}}" class="" data-lightbox="cm-gallery">
                <img src="{{fixThumbnailImage(listingMedia.url)}}" class="img-responsive" alt="" style="max-width: 380px; height: 219px;"></a>
            </div>
          }


        </div>
      </div>
    </section>

    <!-- Details Section -->
    <section id="details">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">

            <h2 class="section-heading">Details</h2>

            <h3 class="">{{ selectedListing.community }}</h3>
            <h4 class="subtext">Offered at {{ selectedListing.listingPrice | currency : '' : 'symbol' : '1.0-0' }}</h4><h4 class="">
            {{ selectedListing.municipality }}</h4>

            <h5 class="bottom-push">
              <span class="text-muted thin">Status </span> <span
              *ngIf="selectedListing.listingStatus==='A' || selectedListing.listingStatus==='Active' || selectedListing.listingStatus==='ACTIVE'">Active</span></h5>

            <div class="row">

              <div class="col-md-2 col-md-offset-2">
                <h2 class="section-heading text-muted">
                  {{ selectedListing.bedroomsTotal }}</h2>

                <h3 class="section-subtext">Bedrooms</h3>
              </div>
              <div class="col-md-2">
                <h2 class="section-heading text-muted">
                  {{ selectedListing.bathroomsTotal }}</h2>
                <h3 class="section-subtext">Bathrooms</h3>
              </div>

              <span *ngIf="(selectedListing.listingStatus | lowercase)!=='rental'" class="row">
                            <div class="col-md-2" *ngIf="selectedListing.sourceStr==='TREB' && selectedListing.lotSize">
                                <h2 class="section-heading text-muted">{{ selectedListing.lotSize }}</h2>
                                <h3 class="section-subtext">Acres</h3>
                            </div>
                            <div class="col-md-2" *ngIf=" selectedListing.squareFootage">
                                <h2 class="section-heading text-muted">{{ selectedListing.squareFootage }}</h2>

                                <h3 class="section-subtext">Sq. Ft.</h3>
                            </div>
                        </span>

            </div>

            <h3 class="top-push">Property Description</h3>

            <p class="top-push" [innerHTML]="selectedListing.description"></p>

            <p class="top-push">Listing courtesy of {{ selectedListing.listingBrokerage }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">

          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section id="contact">
      <div class="container">
        <contact-form [selectedListing]="selectedListing"></contact-form>
      </div>
    </section>
  </div>

  <my-footer></my-footer>
</div>
